import getGlobals from './globals';
import { communities, deactivateCommunityMarkers } from '../communities';
import { products, deactivateProductMarkers } from '../products';
import { getQueryStringValueByName, getDocumentFilterValueByName } from '../utilities';

export default async () => {
    const globals = getGlobals({ mapContainer: 'product-search-map'});

    // Set up global variables
    globals.apiRoot = getDocumentFilterValueByName('ApiRoot');
    globals.showCommunitySearch = getDocumentFilterValueByName('CommunitiesSearch');
    let parentFolderIdValue = getDocumentFilterValueByName('ParentFolderIds');
    if (parentFolderIdValue) {
        globals.parentFolderIds = parentFolderIdValue.split(',');
    }

    globals.productFilter = getQueryStringValueByName('productTypes');
    globals.regionFilter = getQueryStringValueByName('region');
    globals.statusFilter = getQueryStringValueByName('status');
    let projectIdValue = getDocumentFilterValueByName('ProjectIds');
    if (projectIdValue) {
        globals.projectIds = projectIdValue.split(',');
    }

    globals.showHideInfoWindow = (marker, contentString) => {
        deactivateProductMarkers();
        deactivateCommunityMarkers();
        globals.infoWindow.close();

        if (marker) {
            globals.infoWindow.setContent(contentString);
            globals.infoWindow.open(globals.map, marker);

            // add (Map Interaction) when customer clicks on pin
            gtmClickPinOnMap(contentString);

            // add click event here for (Select Item from Map) as the id should be in the dom now ... 
            var identifiers = getIdentifiers(contentString); // because there may be more than one.

            setTimeout(function () { // first attempt found that on first load of page the button isn't found. subsequent attempts are fine. Have added small delay to allow the button to be available on first load.
                identifiers.forEach(function (identifier) {
                    var leBooton = document.getElementById(identifier);
                    if (leBooton != null) {
                        leBooton.addEventListener("click", gtmSelectItemFromMap.bind(null, contentString, identifier), false);
                    }
                });
            }, 1000);
        }
    };

    // Communities (Map only)
    if (globals.showCommunitySearch) {
        communities(globals);
    }
    else if (globals.projectIds) {
        if (globals.projectIds.length > 0) {
            await products(globals);
        }
    }

    // Allow scrollwheel to zoom after map is clicked... if there is a map
    if (globals.map !== undefined) {
        google.maps.event.addListener(globals.map, 'click', function (event) {
            this.setOptions({ scrollwheel: true });
            globals.showHideInfoWindow(null, null);
        });
    }

    var gtmClickPinOnMap = function (data) { // (Map Interaction) 
        console.log("GTM pin click fired");

        // determine if community or lot
        var listName = "Lot List"
        if (data.includes("GTMCommId_")) {
            listName = "Community List"
        }

        // populate community 
        var community = {
            name: getData("data-name", data) || "corporate",
            region: getData("data-region", data),
            availability: getData("data-availablity", data)
        }

        //  populate lot (maybe undefined if it's a community list) maybe more than one if there's more than one product for a lot
        //  if more than one data-blah will be data-blah#
        var items = [];
        var productCount = getData("data-productCount", data);
        if (productCount != null) {
            var productCountNumber = parseInt(productCount);
            if (!isNaN(productCountNumber)) {
                if (productCountNumber > 1) {
                    //  do each data-blah# where # is the productCount
                    for (var i = 0; i < productCountNumber; i++) {
                        // NOTE some of the data- are not product specific, eg lotsize will be teh same for all products
                        var lot = {
                            name: getData("data-product-name", data),
                            type: getData("data-type" + i, data),
                            size: getData("data-size", data),
                            price: getData("data-price" + i, data),
                            stage: getData("data-stage", data),
                            bedrooms: getData("data-bedrooms" + i, data),
                            bathrooms: getData("data-bathrooms" + i, data),
                            car_spaces: getData("data-car_spaces" + i, data),
                            stories: getData("data-stories" + i, data),
                            product_id: getData("data-product_id" + i, data),
                            open_times: getData("data-open_times", data),
                            builder: getData("data-builder" + i, data),
                            frontage: getData("data-frontage", data)
                        }
                        items.push(lot);
                    }
                } else {
                    var lot = {
                        name: getData("data-product-name", data),
                        type: getData("data-type", data),
                        size: getData("data-size", data),
                        price: getData("data-price", data),
                        stage: getData("data-stage", data),
                        bedrooms: getData("data-bedrooms", data),
                        bathrooms: getData("data-bathrooms", data),
                        car_spaces: getData("data-car_spaces", data),
                        stories: getData("data-stories", data),
                        product_id: getData("data-product_id", data),
                        open_times: getData("data-open_times", data),
                        builder: getData("data-builder", data),
                        frontage: getData("data-frontage", data)
                    }
                    items.push(lot);
                }
			}
             
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "map_interaction",
            item_list_name: listName,
            community: community,
            lot: items
        });

    }

    var gtmSelectItemFromMap = function (data, identifier) { // (Select Item from Map)
        console.log('gtm select item from map fired');

        // determine if this is a community or a lot
        var listName = "Lot List"
        if (identifier.includes("GTMCommId_")) {
            listName = "Community List"
        }

        // get data for item
        var item;
        if (listName == "Community List") {
            item = {
                community_name: getData("data-name", data),
                community_region: getData("data-region", data),
                community_availability: getData("data-availablity", data)
            }
        } else {
            // need to determine which productCount this one is if there is more than one
            var productCount = getData("data-productCount", data);
            if (productCount != null) {
                var productCountNumber = parseInt(productCount);
                if (!isNaN(productCountNumber)) {
                    if (productCountNumber == 1) {
                        item = {
                            item_id: getData("data-product_id", data),
                            item_name: getData("data-product-name", data),
                            item_brand: getData("data-builder", data),
                            lot_name: getData("data-product-name", data),
                            lot_type: getData("data-type", data),
                            lot_size: getData("data-size", data),
                            lot_price: getData("data-price", data),
                            lot_stage: getData("data-stage", data),
                            lot_bedrooms: getData("data-bedrooms", data),
                            lot_bathrooms: getData("data-bathrooms", data),
                            lot_car_spaces: getData("data-car_spaces", data),
                            lot_stories: getData("data-stories", data),
                            lot_product_id: getData("data-product_id", data),
                            lot_open_times: getData("data-open_times", data),
                            lot_builder: getData("data-builder", data),
                            lot_frontage: getData("data-frontage", data)
                        }
                    } else {
                        // for each data-product_id# find the one that matches the GTMblahId_GUID then extract for that.

                        for (var i = 0; i < productCountNumber; i++) {
                            // i = suffix
                            // given identifier, get data-product_id[suffix] and work out which productCount is this one
                            var dataObjName = "data-product_id";

                            var test = getData(dataObjName.concat(i), data);

                            if (test == identifier.substring(10)) {
                                item = {
                                    item_id: getData("data-product_id" +i, data),
                                    item_name: getData("data-product-name", data),
                                    item_brand: getData("data-builder" +i, data),
                                    lot_name: getData("data-product-name", data),
                                    lot_type: getData("data-type" + i, data),
                                    lot_size: getData("data-size", data),
                                    lot_price: getData("data-price" + i, data),
                                    lot_stage: getData("data-stage", data),
                                    lot_bedrooms: getData("data-bedrooms" + i, data),
                                    lot_bathrooms: getData("data-bathrooms" + i, data),
                                    lot_car_spaces: getData("data-car_spaces" + i, data),
                                    lot_stories: getData("data-stories" + i, data),
                                    lot_product_id: getData("data-product_id" + i, data),
                                    lot_open_times: getData("data-open_times", data),
                                    lot_builder: getData("data-builder" + i, data),
                                    lot_frontage: getData("data-frontage", data)
                                }
                            }
                        }
                    }
				}
                
			}            
        }

        var ecommerceItem = {};
        if (listName == "Community List") {
            ecommerceItem.item_list_name = listName;
            ecommerceItem.items = [item];

        }
        else {
            //this is for lots only
            ecommerceItem.item_list_name = listName;            
            ecommerceItem.items = [item];
		}

        

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "select_item",
            ecommerce: ecommerceItem
        });
    }
};

function getIdentifiers(contentString) {
    // id will start with GTMCommId_ or GTMProdId_
    // if it's a product it will have a guid otherwise it will just be the community name as we didn't have the community guid
    // because there may be more than one indentifier in the case of products we're doing it this way.
    
    var identifiers = [];

    var subStrings = contentString.split("><");

    for (var i = 0; i < subStrings.length; i++) {
        if (subStrings[i].includes("id=\"GTMP")) {
            var indexOfId = subStrings[i].indexOf("id=\"GTMP") + 4; // to get beginning of identifier rather than what we searched to find identifier

            identifiers.push(subStrings[i].substring(indexOfId, indexOfId + 46)) // where 46 is the length of the identifier
        }
        else if (subStrings[i].includes("id=\"GTMC")) {
            var indexOfId = subStrings[i].indexOf("id=\"GTMC") + 4; // to get beginning of identifier rather than what we searched to find identifier
            var indexOfEnd = subStrings[i].indexOf("\"", indexOfId + 4); // find next quote after the beginning of the identifer

            identifiers.push(subStrings[i].substring(indexOfId, indexOfEnd))            }
    }
    
    return identifiers;
};

function getData(dataID, data) {
    // find dataID in data and extract value where location is dataID="VALUE"

    if (data.includes(dataID)) {
        var indexOfId = data.indexOf(dataID) + dataID.length + 2; // to get past dataID="
        var indexOfEnd = data.indexOf("\"", indexOfId);
        var result = data.substring(indexOfId, indexOfEnd);

        return result;
    }
}